import axios from "axios";
import { flipmemoApiBase } from "@/config/flipmemoApi";

export function mediaApiBase() {
  return flipmemoApiBase;
}

/**
 * Envia imagem para POST /uploads?folder=avatar|community (Bearer).
 * Backend: MEDIA_STORAGE=local grava em disco; s3 devolve 501 até implementar.
 */
export async function uploadImageFile(file, folder, token) {
  if (!file || !token) {
    throw new Error("Ficheiro ou sessão em falta");
  }
  const fd = new FormData();
  fd.append("file", file);
  const { data } = await axios.post(`${mediaApiBase()}/uploads?folder=${encodeURIComponent(folder)}`, fd, {
    headers: { Authorization: `Bearer ${token}` },
  });
  if (!data?.url) {
    throw new Error("Resposta de upload inválida");
  }
  return data.url;
}
